import { theme } from "../../theme";
export const LeadRetrieval = {
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  badgeWrapper: {
    height: "calc(100vh - 105px)",
    display: "flex",
    flexDirection: "column",
    width: "24%",
  },
  topActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  topFilters: {
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  userIcon: {
    position: "relative",
    top: "3px",
    marginRight: "7px",
    color: theme.palette.text.primary,
    fontSize: "18px",
  },
  searchForm: {
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
  },
  searchInput: {
    flex: 1,
    border: 0,
    boxShadow: "none",
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    "&.MuiFormControl-root": {
      m: 0,
    },
    "& .MuiInputBase-root": {
      padding: "9px 10px 9px 10px",
      borderTopRightRadius: "0 !important",
      borderBottomRightRadius: "0 !important",
    },
  },
  searchButton: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: "5px",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: "5px",
  },
  listContent: {
    position: "relative",
    width: "100%",
    overflow: "auto",
    height: "100%",
  },
  listContentActions: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "10px",
  },
  selectedFilters: {},
  filterChip: {
    marginBottom: "5px",
    marginRight: "5px",
    float: "left",
  },
  clearIcon: {
    cursor: "pointer",
    marginRight: "10px",
  },
  registrationStatus: {
    fontSize: "10px",
    paddingLeft: "5px",
    paddingRight: "5px",
    borderRadius: "5px",
    color: "#fff",
  },
  groupIcon: {
    position: "relative",
    top: "3px",
    marginRight: "7px",
    color: theme.palette.text.primary,
    fontSize: "18px",
  },
  subtitleStyle: { lineHeight: 1, fontSize: "14px", color: "#787878" },
  subDiv: { display: "flex", alignItems: "center", gap: 2 },
  loadingBox: {
    width: "100%",
    height: "100%",
    "& > div": { marginTop: "0px", paddingTop: "50px", height: "auto" },
  },
  emptyScreen: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    "& .iconStyle":{
      mb: 2,
      background:
        "linear-gradient(139.4deg, rgba(123,123,123, 0.2) 4.09%, rgba(123,123,123, 0) 87.78%)",
      height: "150px",
      width: "150px",
      borderRadius: "50%",
      mx: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }
  },
  totalIcon:{
    position: "relative",
    top: "3px",
    marginRight: "7px",
    color: theme.palette.text.primary,
    fontSize: "18px",
  }
} as const;
